export const BUDGET_ONBOARDING_STEPS = [
    'link-accounts',
    'income',
    'transactions-syncing',
    'fixed-expenses',
    'lifestyle-expenses',
    'saving-investing',
    'confirmation',
] as const;

export type BudgetOnboardingStep = (typeof BUDGET_ONBOARDING_STEPS)[number];
